import common from "../../common";
import MiniSignal from "mini-signals";
import ControlMethod from "./ControlMethod";

export default class ControlMethodKeys extends ControlMethod
{
    constructor(fighter)
    {
        super(fighter);
        
        this.init();
    }
}